'use strict'

class SimulatorGraph {

    constructor(data) {
        this.data = data;
    }

    filter(year){
        return this.data.find((dt) => {
            return dt.edad == year;
        });
    }

    getDataField(field){
        return this.data.map((doc) => {
            return doc.jubilacion_total_con_art_8 !== 0 && doc.jubilacion_total_con_art_8 !== 0 ? doc[field] : false;
        }).filter((doc) => {
            return doc !== false ? true : false;
        });
    }
}

export default SimulatorGraph;